import { render, staticRenderFns } from "./FormatsList.vue?vue&type=template&id=5d9b9f8e&scoped=true"
import script from "./FormatsList.vue?vue&type=script&lang=js"
export * from "./FormatsList.vue?vue&type=script&lang=js"
import style0 from "./FormatsList.vue?vue&type=style&index=0&id=5d9b9f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b9f8e",
  null
  
)

export default component.exports